import { render } from "./Mockup.vue?vue&type=template&id=44df7c3a"
import script from "./Mockup.vue?vue&type=script&lang=js"
export * from "./Mockup.vue?vue&type=script&lang=js"

import "./Mockup.vue?vue&type=style&index=0&id=44df7c3a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/components/Mockup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44df7c3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44df7c3a', __exports__)) {
    api.reload('44df7c3a', __exports__)
  }
  
  module.hot.accept("./Mockup.vue?vue&type=template&id=44df7c3a", () => {
    api.rerender('44df7c3a', render)
  })

}


export default __exports__